import type { Routes } from '@angular/router';
import { OnyxFormMode } from '@onyx/angular';
import type { FormResolverData } from '../../common/interfaces/common/form-resolver-data';
import { importGuard } from '../common/guards/import.guard';
import { getOrderImportColumns } from './common/constants/orders-import-columns';
import type { OrderForm } from './common/helpers/order-form.helper';
import { addOrderResolver } from './common/resolvers/add-order.resolver';
import { editOrderResolver } from './common/resolvers/edit-order.resolver';
import { importOrdersResolver } from './common/resolvers/import-orders.resolver';
import { orderCardResolver } from './common/resolvers/order-card.resolver';
import { orderManualRouteResolver } from './common/resolvers/order-manual-route.resolver';

export type OrderFormResolverData = FormResolverData<OrderForm>;

export const ORDERS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./orders-list/orders-list.component').then(
        (m) => m.OrdersListComponent,
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./order-form/order-form.component').then(
        (m) => m.OrderFormComponent,
      ),
    data: { mode: OnyxFormMode.ADD },
    resolve: { data: addOrderResolver },
  },
  {
    path: 'import',
    loadComponent: () =>
      import('../common/components/import/import-result/import-result.component').then(
        (m) => m.ImportResultComponent,
      ),
    canActivate: [importGuard],
    data: { columns: getOrderImportColumns() },
    resolve: { import: importOrdersResolver },
  },
  {
    path: ':uuid',
    children: [],
    resolve: { _: orderCardResolver },
  },
  {
    path: ':uuid/edit',
    loadComponent: () =>
      import('./order-form/order-form.component').then(
        (m) => m.OrderFormComponent,
      ),
    data: { mode: OnyxFormMode.EDIT },
    resolve: { data: editOrderResolver },
  },
  {
    path: ':uuid/manual-route',
    loadComponent: () =>
      import('./order-manual-route/order-manual-route.component').then(
        (m) => m.OrderManualRouteComponent,
      ),
    resolve: { data: orderManualRouteResolver },
  },
] as const;
